import axios from '../../config/axios';
import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';

export const getAllProcessorTerminals = (data) => ({
    type: 'GET_PROCESSOR_TERMINALS',
    data
})

export const getProcessorTerminalData = (data) => ({
    type: 'GET_PROCESSOR_TERMINAL_DATA',
    data
})

export const getFilteredData = (data) => ({
    type: 'FILTER_PROCESSOR_TERMINALS',
    data
})

export const setProcessorTerminalEdit = (data) => ({
    type: 'SET_EDIT',
    data
})

export const setProcessorTerminalID = (data) => ({
    type: 'SET_PROCESSOR_TERM_ID',
    data
})

export const setClone = (data) => ({
    type: 'SET_CLONE',
    data
})


export const setExist = (data) => ({
    type: 'SET_EXIST',
    data
})


export const setProcessorID = (data) => ({
    type: 'SET_PROCESSOR_ID',
    data
})

export const setModified = (data) => ({
    type: 'SET_MODIFIED',
    data
})

export const setTerminalBatchData = (data) => ({
    type: 'SET_PROCESSOR_BATCH_DATA',
    data
})

export const setCassetteData = (data) => ({
    type: 'SET_CASSETTE_DATA',
    data
})

export const setLoadingBatchData = (data) => ({
    type: 'LOADING_BATCH_DATA',
    data
})

export const setKeysData = (data) => ({
    type: 'KEYS_DATA',
    data
})


export const fetchAllProcessorTerminals = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/getAllTerminals`).then(response => {
            if (response.status === 200) {
                dispatch(getAllProcessorTerminals(response.data));
            } else {
                dispatch(getAllProcessorTerminals([]));
            }
        }).catch(error => {
            dispatch(getAllProcessorTerminals([]));
        })
    }
}

export const fetchProcessorTerminal = (terminalID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/getProcessorTerminalData/${terminalID}`).then(response => {
            if (response.status === 200) {
                dispatch(getProcessorTerminalData([response.data]));
            } else {
                dispatch(setSnackbar(true, 'error', 'Terminal ID entered is not present'))
                dispatch(getProcessorTerminalData([]));

            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Terminal ID entered is not present'))
            dispatch(getProcessorTerminalData([]));
        })
    }
}


export const addProcessorTerminal = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/processorTerminal/addProcessorTerminal`, body).then(response => {
            if (response.status === 200) {
                dispatch(setModified(true))
                console.log(response.data.processorTermID)
                dispatch(setProcessorTerminalID(response.data.processorTermID))
                dispatch(setSnackbar(true, 'success', 'Terminal Added Successfully'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const editProcessorTerminal = (body) => {
    return function (dispatch) {
        axios.put(`${config.api.FETCH_URL}/processorTerminal/editProcessorTerminal`, body).then(response => {
            if (response.status === 200) {
                dispatch(setModified(true))
                dispatch(setProcessorTerminalID(response.data.processorTermID))
                dispatch(setSnackbar(true, 'success', 'Terminal Updated Successfully'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const checkTerminalID = (terminalID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/isProcessorTerminalExists/${terminalID}`).then(response => {
            if (response.status === 200) {
                if (response.data.status === 'Fail') {
                    dispatch(setExist(true))
                    dispatch(setSnackbar(true, 'error', 'Terminal ID Exists'))
                } else {
                    dispatch(setExist(false))
                }
            }
        }).catch(error => {
            // dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const filteredData = (data) => {
    return function (dispatch) {
        dispatch(getFilteredData(data))
    }
}

export const checkProcessorTerminalID = (processorTerminalID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/isProcessorTerminalExists/${processorTerminalID}`).then(response => {
            if (response.status === 200) {
                if (response.data.status === 'Fail') {
                    dispatch(setExist(true))
                    dispatch(setSnackbar(true, 'error', 'Terminal ID Exists'))
                } else {
                    dispatch(setExist(false))
                }
            }
        }).catch(error => {
            // dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}


export const fetchTerminalBatchData = (processorTerminalID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/getTerminalBatchTotals/${processorTerminalID}`).then(response => {
            if (response.status === 200) {
                dispatch(setTerminalBatchData(response.data));
                console.log('Terminal Batch Data : ' + response.data.termID)
            } else {
                dispatch(setTerminalBatchData([]));
            }
        }).catch(error => {
            dispatch(setTerminalBatchData([]));
        })
    }
}

export const closeProcessorTerminalBatch = (body) => {
    return function (dispatch) {
        console.log('Batch request : ' + body.processorTermID)
        axios.post(`${config.api.KEYS_URL}/terminalProcManagement/closeBatch`, body).then(response => {
            if (response.status === 200) {
                dispatch(setSnackbar(true, 'success', 'Terminal Batchclose Successful'))
                dispatch(fetchTerminalBatchData(body.processorTermID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
        dispatch(setLoadingBatchData(false))
    }
}

export const resetProcessorTerminalSessionKey = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.KEYS_URL}/terminalProcManagement/resetKey`, body).then(response => {
            if (response.status === 200) {
                dispatch(setSnackbar(true, 'success', 'Terminal Reset key Successful'))
                dispatch(fetchProcessorTerminal(body.processorTermID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
        dispatch(setLoadingBatchData(false))
    }
}

export const addKeys = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.KEYS_URL}/terminalProcManagement/import-one`, body).then(response => {
            if (response.status === 200) {
                dispatch(setKeysData(response.data))
                if (response.data.status === 'Successful') {
                    dispatch(setSnackbar(true, 'success', 'Terminal keys added Successful'))
                    dispatch(fetchProcessorTerminal(body.processorTermID))
                }else {
                    dispatch(setSnackbar(true, 'error', 'Failed Adding keys'))
                }
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
        dispatch(setLoadingBatchData(false))
    }
}


export const fetchCassetteData = (terminalID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/getCassetteData/${terminalID}`).then(response => {
            if (response.status === 200) {
                dispatch(setCassetteData([]));
                dispatch(setCassetteData(response.data));
                console.log('Terminal Cassette : ' + response.data.terminalID)
            } else {
                dispatch(setCassetteData([]));
            }
        }).catch(error => {
            dispatch(setCassetteData([]));
        })
    }
}

export const updateCassetteData = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/processorTerminal/editCassetteData`, body).then(response => {
            if (response.status === 200) {
                dispatch(setCassetteData(response.data));
                console.log('Terminal Cassette : ' + response.data)
            } else {
                dispatch(setCassetteData([]));
            }
        }).catch(error => {
            dispatch(setCassetteData([]));
        })
    }
}

export const updateProcessorTermSeq = (terminalID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/processorTerminal/updateSeqNum/${terminalID}`).then(response => {
            if (response.status === 200) {
                dispatch(setSnackbar(true, 'success', 'Updated Sequence Number'))
                dispatch(fetchProcessorTerminal(terminalID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Could not update Seq'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Could not update Seq'))
        })
    }
}
